/************************************************************************************
  Customize the application by changing the values in this file
*************************************************************************************/

export const config = {
  styledText: "Beall AI Portal",
  applicationName: "Beall AI Portal",
  companyName: "UCI",
  applicationSummary:
    "The portal uses AI to provide insights into expertise and knowledge across the UCI ecosystem, including publications, grants, patents, and other academic contributions. Ask questions to begin a conversation with the portal. Like a virtual assistant, it allows you to refine your queries, explore deeper insights, and discover the information you need. Start with your own question or select a sample query below to see how it works.",
};

export const exampleQuestions = [
  "Help me look for grants in environmental sustainability.",
  "See if any patents have been issued around neurological disorders.",
  "Tell me about faculty at UCI who are researching natural language processing.",
];
